export default "__VITE_ASSET__Ds4MJ3kN__"